import { useEffect, useRef } from 'react';
import deepEqual from 'react-fast-compare';

/*
  useEffectDeep: Similar to useEffect, but compares dependencies deeply before
  executing callback.
*/

export function useDeepEffect(
  callback: () => (() => void) | void,
  dependencies: Array<unknown>,
) {
  // State and setters for debounced value
  const ref = useRef();

  if (!deepEqual(dependencies, ref.current)) {
    // @ts-expect-error TS(2322): Type 'unknown[]' is not assignable to type 'undefi... Remove this comment to see the full error message
    ref.current = dependencies;
  }

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(callback, ref.current);
}
